import { useNavigate } from 'react-router-dom'

const TEAM = [
  {
    name: 'Венди',
    role: 'Поддержка и глубина',
    desc: 'Тепло, принятие, работа с эмоциями. ACT, IFS, SFBT, Somatic.',
    color: 'bg-wendy',
    avatar: '/avatars/wendy.png',
  },
  {
    name: 'Артём',
    role: 'Честность и движение',
    desc: 'Прямой разговор, вызов, не даёт застрять. REBT, Gestalt, Reality Therapy.',
    color: 'bg-artem',
    avatar: '/avatars/artem.png',
  },
  {
    name: 'Уна',
    role: 'Отношения и близость',
    desc: 'Расставания, привязанность, одиночество. EFT, Gottman, Schema Therapy.',
    color: 'bg-una',
    avatar: '/avatars/una.png',
  },
  {
    name: 'Гарольд',
    role: 'Координатор',
    desc: 'Видит общую картину, ведёт стратегию, проводит консилиумы.',
    color: 'bg-finch',
    avatar: '/avatars/finch.png',
  },
]

const METHODS = [
  'ACT (Acceptance & Commitment Therapy)',
  'IFS (Internal Family Systems)',
  'SFBT (Solution-Focused Brief Therapy)',
  'REBT (Rational Emotive Behavior Therapy)',
  'Gestalt Therapy',
  'EFT (Emotionally Focused Therapy)',
  'Gottman Method',
  'Attachment Theory',
  'Schema Therapy',
  'Somatic Experiencing',
  'Narrative Therapy',
  'Provocative Therapy',
  'Cognitive Behavioral Coaching',
]

export default function HelpPage() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-gradient-to-b from-neutral-50 to-white safe-area-pt safe-area-pb">
      {/* Header */}
      <header className="glass border-b border-neutral-200/50 sticky top-0 z-10">
        <div className="max-w-2xl mx-auto px-4 py-3 flex items-center gap-3">
          <button
            onClick={() => navigate(-1)}
            className="btn-ghost p-2 rounded-xl"
            aria-label="Назад"
          >
            <svg className="w-5 h-5 text-neutral-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <h1 className="font-semibold text-neutral-800">О Janus Therapy</h1>
        </div>
      </header>

      {/* Content */}
      <div className="max-w-2xl mx-auto px-4 py-6 space-y-6">

        {/* 1. Why */}
        <section className="card">
          <h2 className="text-base font-semibold text-neutral-800 mb-2">Зачем это существует</h2>
          <p className="text-sm text-neutral-600 leading-relaxed">
            Многие годами не обращаются за помощью — стыдно, страшно, &laquo;не настолько всё плохо&raquo;.
            Janus Therapy создан чтобы этот барьер убрать.
          </p>
          <p className="text-sm text-neutral-600 leading-relaxed mt-2">
            Здесь можно начать разговор о том, что болит — без осуждения, без записи, без очереди.
            А когда будешь готов к живому специалисту — мы поможем сделать этот шаг.
          </p>
        </section>

        {/* 2. What we do */}
        <section className="card">
          <h2 className="text-base font-semibold text-neutral-800 mb-2">Что мы делаем</h2>
          <p className="text-sm text-neutral-600 leading-relaxed">
            Команда из 4 AI-специалистов с разными подходами. Не один бот с шаблонами — реальная терапевтическая работа.
          </p>
          <ul className="mt-3 space-y-2 text-sm text-neutral-600">
            <li className="flex gap-2">
              <span className="text-primary-500 font-bold mt-0.5">*</span>
              <span><strong>Консилиум</strong> — твой случай обсуждается командой, как в настоящей клинике</span>
            </li>
            <li className="flex gap-2">
              <span className="text-primary-500 font-bold mt-0.5">*</span>
              <span><strong>Индивидуальный план</strong> — не &laquo;советы из интернета&raquo;, а стратегия для тебя</span>
            </li>
            <li className="flex gap-2">
              <span className="text-primary-500 font-bold mt-0.5">*</span>
              <span><strong>Доказательные методики</strong> — 13+ подходов из мировой психотерапии</span>
            </li>
          </ul>
        </section>

        {/* 3. Team */}
        <section className="card">
          <h2 className="text-base font-semibold text-neutral-800 mb-3">Команда</h2>
          <div className="space-y-3">
            {TEAM.map((t) => (
              <div key={t.name} className="flex items-start gap-3">
                <div className={`w-10 h-10 ${t.color} rounded-full overflow-hidden flex-shrink-0`}>
                  <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <p className="text-sm font-medium text-neutral-800">{t.name} <span className="font-normal text-neutral-500">— {t.role}</span></p>
                  <p className="text-xs text-neutral-500 leading-relaxed">{t.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* 4. How it works */}
        <section className="card">
          <h2 className="text-base font-semibold text-neutral-800 mb-2">Как это работает</h2>
          <div className="space-y-2 text-sm text-neutral-600 leading-relaxed">
            <p>
              Пишешь, говоришь голосом, отправляешь видео. Терапевт слушает, задаёт вопросы, помогает разобраться.
            </p>
            <p>
              Не даёт готовых ответов — помогает найти свои.
              Не торопит — работает в твоём темпе.
            </p>
          </div>
        </section>

        {/* 5. Methods */}
        <section className="card">
          <h2 className="text-base font-semibold text-neutral-800 mb-2">Методики</h2>
          <p className="text-sm text-neutral-600 mb-3">
            Мы используем доказательные подходы из мировой психотерапии:
          </p>
          <div className="flex flex-wrap gap-1.5">
            {METHODS.map((m) => (
              <span key={m} className="text-xs bg-neutral-100 text-neutral-600 px-2 py-1 rounded-full">
                {m}
              </span>
            ))}
          </div>
        </section>

        {/* 6. What we don't do */}
        <section className="card">
          <h2 className="text-base font-semibold text-neutral-800 mb-2">Чего мы не делаем</h2>
          <p className="text-sm text-neutral-600 mb-2">Честно и без страха:</p>
          <ul className="space-y-1.5 text-sm text-neutral-600">
            <li className="flex gap-2">
              <span className="text-neutral-400">—</span>
              <span>Не ставим диагнозы</span>
            </li>
            <li className="flex gap-2">
              <span className="text-neutral-400">—</span>
              <span>Не назначаем лекарства</span>
            </li>
            <li className="flex gap-2">
              <span className="text-neutral-400">—</span>
              <span>Не заменяем врача или живого психолога</span>
            </li>
            <li className="flex gap-2">
              <span className="text-neutral-400">—</span>
              <span>Наша цель — чтобы ты стал сильнее и при необходимости дошёл до специалиста</span>
            </li>
          </ul>
        </section>

        {/* 7. Safety */}
        <section className="card">
          <h2 className="text-base font-semibold text-neutral-800 mb-2">Безопасность</h2>
          <p className="text-sm text-neutral-600 leading-relaxed">
            Конфиденциально. Можешь остановиться когда хочешь. В кризисных ситуациях — направим к живым людям.
          </p>
        </section>

        {/* 8. Encouragement */}
        <section className="card bg-primary-50/50 border-primary-200/50">
          <p className="text-sm text-neutral-700 leading-relaxed font-medium text-center">
            То, что ты здесь — уже шаг. Не маленький.
          </p>
          <p className="text-sm text-neutral-600 leading-relaxed text-center mt-1">
            Давай разберёмся вместе.
          </p>
        </section>

        {/* Back button */}
        <div className="pt-2 pb-4">
          <button
            onClick={() => navigate(-1)}
            className="w-full py-3 rounded-xl bg-neutral-100 hover:bg-neutral-200 text-sm font-medium text-neutral-700 transition-colors"
          >
            Вернуться
          </button>
        </div>
      </div>
    </div>
  )
}
